import type { ScoreResult } from '@/features/scoring/lib/types'
import { getAG } from '@/features/scoring/lib/scoringHelpers'
import type { UFPMMember, UFPMScoreEntry } from './types'

export function scoreEntryToResult(
  entry: UFPMScoreEntry,
  member: Pick<UFPMMember, 'age' | 'sex'>,
): ScoreResult | null {
  if (!entry) return null
  const raw = entry as unknown as Record<string, unknown>
  const age = Number(entry.age || member.age || 0)
  return {
    sex: entry.sex === 'female' ? 'female' : 'male',
    age,
    ag: getAG(age),
    testDate: String(raw.testDate || ''),
    puType: raw.puType === 'hr' ? 'hr' : 'standard',
    puScore: Number(entry.puScore || 0),
    puDetail: String(raw.puDetail || ''),
    puEx: !!entry.puEx,
    coreType: (raw.coreType === 'plank' || raw.coreType === 'clrc') ? raw.coreType : 'situp',
    coreScore: Number(entry.coreScore || 0),
    coreDetail: String(raw.coreDetail || ''),
    coreEx: !!entry.coreEx,
    cardioType: raw.cardioType === 'hamr' ? 'hamr' : 'run',
    cardioScore: Number(entry.cardioScore || 0),
    cardioDetail: String(raw.cardioDetail || ''),
    cardioEx: !!entry.cardioEx,
    whtrScore: Number(entry.whtrScore || 0),
    whtrDetail: String(raw.whtrDetail || ''),
    whtrEx: !!entry.whtrEx,
    composite: Number(entry.composite || 0),
    cat: entry.cat === 'EXCELLENT' || entry.cat === 'SATISFACTORY'
      ? entry.cat
      : 'UNSATISFACTORY',
    fails: [],
  }
}
